
export default AccountAddresses = () => {
    const sections = document.querySelectorAll('[data-customer-addresses]');

    for (const section of sections) {
        setTimeout(() => {
            const countrySelects = section.querySelectorAll(
                '[data-address-country-select]',
            );
        
            countrySelects.forEach((select) => {
                const formId = select.dataset.formId;
                new Shopify.CountryProvinceSelector(
                `AddressCountry${formId}`,
                `AddressProvince${formId}`,
                {
                    hideElement: `AddressProvinceContainer${formId}`,
                },
                );
            });
        }, 2000);
    }
}